<template>
  <InputSelect
    :disabled="props.disabled"
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="wasteCodes"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    Codice Rifiuto
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

const props = defineProps({
  errorFields: {
    required: true,
    type: Object
  },
  submitted: {
    required: true,
    type: Boolean,
  },
  name: {
    required: true,
    type: String,
  },
  modelValue: {
    default: null,
    type: String,
  },
  disabled: {
    default: false,
    type: Boolean,
  }
})

defineEmits(['update:modelValue'])

const axios = useAxios()

const wasteCodeResp = await axios.get('/waste-code/list')
const wasteCodes = wasteCodeResp.data.map((wasteCode) => {
  return {
    id: wasteCode.uuid,
    label: wasteCode.code
  }
})

</script>